var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail-page"},[_c('header-back',{attrs:{"title":_vm.title},on:{"back":_vm.onClickBack}}),(!_vm.loading)?_c('my-form',{attrs:{"data":_vm.baseFormData}}):_c('cube-loading',{attrs:{"size":24}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }